import CustomTable from '../../../../../components/table/CustomTable';
import AccessLogSectionApp from '../Functionality/AccessLogSectionApp';
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
const AccessLogSection = () => {
     const {
         tableId,
         searchId,
         thead,
         tbody,
         getActionsButtons,
         pagination
     } = AccessLogSectionApp();

    return (
        <div >
            <CustomTable
                tableId={tableId}
                searchId={searchId}
                checkbox={false}
                thead={thead}
                tbody={tbody}
                columnActions={false}
                getActionsButtons={getActionsButtons}
                textNotInformation={'no_access_log'}
                withoutHeight={true}
            />
            {pagination()}
        </div>
    );
};

export default AccessLogSection;
